import { DefaultInputTreeNode, IdType } from '../types';

export const defaultGetIdFromNode = <
  InputTreeNode extends DefaultInputTreeNode,
>(
  node: InputTreeNode,
) => node.id as IdType;

export const defaultGetLabelFromNode = <
  InputTreeNode extends DefaultInputTreeNode,
>(
  node: InputTreeNode,
) => node.label as string;

export const defaultGetChildrenFromNode = <
  InputTreeNode extends DefaultInputTreeNode,
>(
  node: InputTreeNode,
) => node.children as InputTreeNode[];
